import React from "react";
import { motion } from "framer-motion";
import ceo from "../assets/images/CEO2.png";
import thushara from "../assets/images/BM11.png";
import nirmani from "../assets/images/BM22.png";

const teamMembers = [
    {
        name: "SAMEERA HEWA NADUGALAGE",
        position: [
            "Chief Executive Officer",
            "Operation Manager",
            "Facility Manager",
        ],
        image: ceo,
    },
    {
        name: "THUSHARA DIMUTHU",
        position: [
            "Head of Telecommunication Division",
            "Business Development Manager",
        ],
        image: thushara,
    },
    {
        name: "NIRMANI THARAKA",
        position: ["Administrative Officer"],
        image: nirmani,
    },
];

const About = () => {
    return (
        <section id="about" className="py-8 md:py-16 bg-white scroll-mt-20">
            <div className="container mx-auto px-4">
                {/* Title */}
                <div className="text-center mb-8 md:mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold">About Us</h2>
                    <div className="w-24 md:w-32 h-0.5 bg-[#FFD700] mx-auto mt-1"></div>
                </div>

                {/* Two Column Content */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 max-w-6xl mx-auto mb-8 md:mb-16">
                    <p
                        className="text-sm md:text-base text-gray-700"
                        style={{ textAlign: "justify" }}
                    >
                        Golden Eagle Management Solutions is a premier facility
                        management company based in the bustling administrative
                        capital of Sri Lanka, Colombo. With over a year of
                        dedicated service, we pride ourselves on delivering
                        top-notch facility management solutions tailored to meet
                        the unique needs of businesses across the island.From
                        office buildings to Industrial complexes, our
                        comprehensive services ensure optimal functionality and
                        efficiency.
                    </p>
                    <p
                        className="text-sm md:text-base text-gray-700"
                        style={{ textAlign: "justify" }}
                    >
                        We are committed to providing island-wide coverage,
                        guaranteeing prompt and reliable assistance whenever and
                        wherever our clients need us. At Golden Eagle Management
                        Solutions, we strive to exceed expectations and elevate
                        the standards of facility management services in Sri
                        Lanka.
                    </p>
                </div>

                {/* Top Line */}
                <div className="w-full h-px bg-gray-200 mb-8 md:mb-12"></div>

                {/* Team Section */}
                <div className="max-w-6xl mx-auto px-4 content-center">
                    <div className="flex flex-col md:flex-row justify-center items-center md:items-start gap-8 md:gap-20 mb-8 md:mb-20">
                        {/* CEO */}
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            className="text-center w-full md:w-auto"
                        >
                            <div className="mb-4">
                                <motion.img
                                    whileHover={{ scale: 1.05 }}
                                    transition={{ duration: 0.3 }}
                                    src={teamMembers[0].image}
                                    alt={teamMembers[0].name}
                                    className="w-32 h-32 md:w-44 md:h-44 object-cover mx-auto"
                                />
                            </div>
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3, duration: 0.5 }}
                            >
                                <h3 className="text-lg md:text-xl font-semibold">
                                    {teamMembers[0].name}
                                </h3>
                                {teamMembers[0].position.map((pos, idx) => (
                                    <p
                                        key={idx}
                                        className="text-xs md:text-sm text-gray-600"
                                    >
                                        {pos}
                                    </p>
                                ))}
                            </motion.div>
                        </motion.div>

                        {/* Other Team Members */}
                        <div className="flex flex-col md:flex-row gap-8 md:gap-20">
                            {teamMembers.slice(1).map((member, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{
                                        delay: index * 0.2,
                                        duration: 0.6,
                                    }}
                                    className="text-center"
                                >
                                    <div className="mb-4">
                                        <motion.div
                                            className="w-32 h-32 md:w-44 md:h-44 overflow-hidden mx-auto"
                                            whileHover={{ scale: 1.05 }}
                                            transition={{ duration: 0.3 }}
                                            style={{ padding: "4px" }}
                                        >
                                            <div className="w-full h-full overflow-hidden">
                                                <img
                                                    src={member.image}
                                                    alt={member.name}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>
                                        </motion.div>
                                    </div>
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{
                                            delay: 0.4 + index * 0.2,
                                            duration: 0.5,
                                        }}
                                    >
                                        <h3 className="text-base md:text-lg font-semibold">
                                            {member.name}
                                        </h3>
                                        {member.position.map((pos, idx) => (
                                            <p
                                                key={idx}
                                                className="text-xs md:text-sm text-gray-600"
                                            >
                                                {pos}
                                            </p>
                                        ))}
                                    </motion.div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bottom Line */}
                <div className="w-full h-px bg-gray-200"></div>
            </div>
        </section>
    );
};

export default About;
